import { Companion_instance2o1tmep3w0ant as Companion_instance } from '../components/project/activity/concerns/IncidentReportForm.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  get_dialogStackleaqvayyucjw as get_dialogStack,
  get_viewIsNarrow26l63sh4olw2h as get_viewIsNarrow,
} from '../components/nav/crowpay.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_mainPageNavigator29w1pddlp5wea as get_mainPageNavigator } from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Dialog1vemwbargnizv as Dialog,
  ProjectMessageThread3bzm1pe4dp4n as ProjectMessageThread,
} from '../components/project/activity/messages.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { ReportIncidentButton_getInstance34farqsakvpxm as ReportIncidentButton_getInstance } from '../theming/formThemes.mjs';
import {
  ButtonFormatting3voagp9s33g1x as ButtonFormatting,
  applyFormatting2iljszizgo9zk as applyFormatting,
} from '../../utils/ButtonAction.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../components/nav/AppDimensions.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance,
  WarningSemantic_getInstance2xxn62yaantj2 as WarningSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { get_centered1xfu6or5nc0lq as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  Frame1e7t2kcdb3wu7 as Frame,
  RowOrCol3a33s3yce2tuv as RowOrCol,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { RemoveOutline_getInstance2r2ekg5cxorga as RemoveOutline_getInstance } from '../theming/appTheme.mjs';
import {
  title1nssp3ryhwuqj as title,
  body3i5t0n7zprpqb as body,
} from '../theming/Titles.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../theming/AppColors.mjs';
import { notificationBar4efejtg2792g as notificationBar } from '../theming/banners.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  get_textButtonybbt8y3eu5hx as get_textButton,
  MessageButton_getInstance33lwpvjn45jp0 as MessageButton_getInstance,
  specCenteredText1zemopd0g3rsf as specCenteredText,
} from '../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp = Companion_instance.vgq($this.yib_1.rib_1, null, emptyList(), $this.yib_1.sib_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0 = tmp;
  // Inline function 'kotlin.apply' call
  $this.yib_1.xib_1(tmp0);
  var form = tmp0;
  if (get_viewIsNarrow($this.zib_1)) {
    get_mainPageNavigator($this.zib_1).dbw(form);
    get_dialogStack().ugg();
  } else {
    get_dialogStack().ebw(form);
  }
  return Unit_instance;
}
function FileIncidentConfirmation$_init_$lambda_8as2ew(_this__u8e3s4) {
  return Unit_instance;
}
var FileIncidentConfirmation$render$slambdaClass;
function FileIncidentConfirmation$render$slambda() {
  if (FileIncidentConfirmation$render$slambdaClass === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    FileIncidentConfirmation$render$slambdaClass = $;
  }
  return FileIncidentConfirmation$render$slambdaClass;
}
function FileIncidentConfirmation$render$slambda_0() {
  var i = new (FileIncidentConfirmation$render$slambda())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var FileIncidentConfirmation$render$slambdaClass_0;
function FileIncidentConfirmation$render$slambda_1() {
  if (FileIncidentConfirmation$render$slambdaClass_0 === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    FileIncidentConfirmation$render$slambdaClass_0 = $;
  }
  return FileIncidentConfirmation$render$slambdaClass_0;
}
function FileIncidentConfirmation$render$slambda_2() {
  var i = new (FileIncidentConfirmation$render$slambda_1())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var FileIncidentConfirmation$render$slambdaClass_1;
function FileIncidentConfirmation$render$slambda_3() {
  if (FileIncidentConfirmation$render$slambdaClass_1 === VOID) {
    class $ {
      constructor($$this$button, this$0) {
        this.aic_1 = $$this$button;
        this.bic_1 = this$0;
      }
      sao($completion) {
        if (get_viewIsNarrow(this.aic_1)) {
          get_mainPageNavigator(this.aic_1).dbw(new (ProjectMessageThread())(this.bic_1.rib_1.x7a_1, this.bic_1.sib_1));
          get_dialogStack().ugg();
        } else {
          get_dialogStack().ebw(new (Dialog())(this.bic_1.sib_1, this.bic_1.rib_1));
        }
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    FileIncidentConfirmation$render$slambdaClass_1 = $;
  }
  return FileIncidentConfirmation$render$slambdaClass_1;
}
function FileIncidentConfirmation$render$slambda_4($$this$button, this$0) {
  var i = new (FileIncidentConfirmation$render$slambda_3())($$this$button, this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var FileIncidentConfirmation$render$slambdaClass_2;
function FileIncidentConfirmation$render$slambda_5() {
  if (FileIncidentConfirmation$render$slambdaClass_2 === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.yib_1 = this$0;
        this.zib_1 = $$this$button;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    FileIncidentConfirmation$render$slambdaClass_2 = $;
  }
  return FileIncidentConfirmation$render$slambdaClass_2;
}
function FileIncidentConfirmation$render$slambda_6(this$0, $$this$button) {
  var i = new (FileIncidentConfirmation$render$slambda_5())(this$0, $$this$button);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var FileIncidentConfirmationClass;
function FileIncidentConfirmation() {
  if (FileIncidentConfirmationClass === VOID) {
    class $ {
      constructor(project, lens, header, p1, p2, acceptButton, setup) {
        header = header === VOID ? 'Are You Sure?' : header;
        p1 = p1 === VOID ? "Informally resolve your concern if it's minor or early in the project by sending a message to your contractor.\n            \nReport an incident if this concern needs to be documented." : p1;
        p2 = p2 === VOID ? 'Informally make aware by sending a message?\nDo you need to formally report this issue?\nFormally make aware X happened and could lead to an issue.' : p2;
        acceptButton = acceptButton === VOID ? ButtonFormatting('Report Incident', ReportIncidentButton_getInstance()) : acceptButton;
        var tmp;
        if (setup === VOID) {
          tmp = FileIncidentConfirmation$_init_$lambda_8as2ew;
        } else {
          tmp = setup;
        }
        setup = tmp;
        this.rib_1 = project;
        this.sib_1 = lens;
        this.tib_1 = header;
        this.uib_1 = p1;
        this.vib_1 = p2;
        this.wib_1 = acceptButton;
        this.xib_1 = setup;
      }
      ud6(_this__u8e3s4) {
        // Inline function 'com.crowpay.views.components.dismissBackground2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.tbo(FileIncidentConfirmation$render$slambda_0());
        view.eba(get_AppDimensions().wg1_1);
        view.zb8(get_AppDimensions().wg1_1);
        var tmp = view.ibb(view.ibb(sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_rem(40)), view.hbb(DialogSemantic_getInstance())), get_centered(view));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.eba(get_AppDimensions().wg1_1);
        var tmp_0 = view_0.hbb(RemoveOutline_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        view_1.xbm(true);
        title(view_1, this.tib_1);
        body(view_1, this.uib_1);
        view_1.jbb(notificationBar(view_1, AppColors_getInstance().jfz_1), body(view_1, this.vib_1));
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (Space())(view_1.pc(), 0.5);
        var tmp0_elvis_lhs_2 = view_1.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.ebb(p_2, view_2);
        view_1.fbb(p_2, view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_3 = view_1.cbb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
        view_1.ebb(p_3, view_3);
        view_3.xbm(false);
        view_3.zb8(get_AppDimensions().ig2_1);
        var tmp_1 = get_textButton(view_3);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (Button())(view_3.pc());
        var tmp0_elvis_lhs_4 = view_3.cbb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
        view_3.ebb(p_4, view_4);
        body(view_4, 'Go Back');
        onClick(view_4, VOID, VOID, FileIncidentConfirmation$render$slambda_2());
        view_3.fbb(p_4, view_4);
        view_3.jbb(tmp_1, view_4);
        // Inline function 'com.lightningkite.kiteui.views.warning' call
        var tmp$ret$6 = view_3.hbb(WarningSemantic_getInstance());
        var tmp_2 = view_3.ibb(tmp$ret$6, view_3.hbb(MessageButton_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (Button())(view_3.pc());
        var tmp0_elvis_lhs_5 = view_3.cbb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_3 : tmp0_elvis_lhs_5;
        view_3.ebb(p_5, view_5);
        specCenteredText(view_5, 'Message');
        onClick(view_5, VOID, VOID, FileIncidentConfirmation$render$slambda_4(view_5, this));
        view_3.fbb(p_5, view_5);
        view_3.jbb(tmp_2, view_5);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (Button())(view_3.pc());
        var tmp0_elvis_lhs_6 = view_3.cbb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_3 : tmp0_elvis_lhs_6;
        view_3.ebb(p_6, view_6);
        applyFormatting(view_6, this.wib_1);
        onClick(view_6, VOID, VOID, FileIncidentConfirmation$render$slambda_6(this, view_6));
        view_3.fbb(p_6, view_6);
        view_1.fbb(p_3, view_3);
        view_0.fbb(p_1, view_1);
        view_0.jbb(tmp_0, view_1);
        view.fbb(p_0, view_0);
        view.jbb(tmp, view_0);
        _this__u8e3s4.fbb(p, view);
        return view;
      }
    }
    protoOf($).ucv = get_title;
    initMetadataForClass($, 'FileIncidentConfirmation', VOID, VOID, [Page()]);
    FileIncidentConfirmationClass = $;
  }
  return FileIncidentConfirmationClass;
}
//region block: exports
export {
  FileIncidentConfirmation as FileIncidentConfirmation1hq6dfo832450,
};
//endregion

//# sourceMappingURL=FileIncidentConfirmation.mjs.map
